/**
 * Generated from BronteSistersStoryLayout.fla
 */
export function BronteSistersStoryLayout(this: IBronteSistersStoryLayout) {
	const scene1Yadina = this.scene1Yadina;
	BronteSistersStoryLayout_scene1Yadina.call(this.scene1Yadina);
	scene1Yadina.x = 0;
	scene1Yadina.y = 0;
	if (scene1Yadina.onLayout) scene1Yadina.onLayout();
	const scene2Xavier = this.scene2Xavier;
	BronteSistersStoryLayout_scene2Xavier.call(this.scene2Xavier);
	scene2Xavier.x = 0;
	scene2Xavier.y = 0;
	if (scene2Xavier.onLayout) scene2Xavier.onLayout();
	const scene3Location = this.scene3Location;
	BronteSistersStoryLayout_scene3Location.call(this.scene3Location);
	scene3Location.x = 0;
	scene3Location.y = 0;
	if (scene3Location.onLayout) scene3Location.onLayout();
	const scene4Floor = this.scene4Floor;
	BronteSistersStoryLayout_scene4Floor.call(this.scene4Floor);
	scene4Floor.x = 0;
	scene4Floor.y = 0;
	if (scene4Floor.onLayout) scene4Floor.onLayout();
	const scene5Bard = this.scene5Bard;
	BronteSistersStoryLayout_scene5Bard.call(this.scene5Bard);
	scene5Bard.x = 0;
	scene5Bard.y = 0;
	if (scene5Bard.onLayout) scene5Bard.onLayout();
	const scene6Rescue = this.scene6Rescue;
	BronteSistersStoryLayout_scene6Rescue.call(this.scene6Rescue);
	scene6Rescue.x = 0;
	scene6Rescue.y = 0;
	if (scene6Rescue.onLayout) scene6Rescue.onLayout();
	return this;
}
export function BronteSistersStoryLayout_scene1Yadina(this: IBronteSistersStoryLayout_scene1Yadina) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotYadina.call(items[0] as IBronteSistersStoryLayout_slotYadina);
		(items[0] as IBronteSistersStoryLayout_slotYadina).animation = "scaleUp ease=squishStretch";
		(items[0] as IBronteSistersStoryLayout_slotYadina).isButton = true;
		(items[0] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[0].x = 978.05;
		items[0].y = 1217.15;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_slotYadina(this: IBronteSistersStoryLayout_slotYadina) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"ringmaster"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broYCostume0.call(items[0] as IBronteSistersStoryLayout_broYCostume0);
		(items[0] as IBronteSistersStoryLayout_broYCostume0).option = "ringmaster";
		items[0].x = -291;
		items[0].y = -878;
		items[0].width = 582.00;
		items[0].height = 878.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"bug"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broYCostume1.call(items[1] as IBronteSistersStoryLayout_broYCostume1);
		(items[1] as IBronteSistersStoryLayout_broYCostume1).option = "bug";
		items[1].x = -286.5;
		items[1].y = -610;
		items[1].width = 573.00;
		items[1].height = 610.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"astronaut"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broYCostume2.call(items[2] as IBronteSistersStoryLayout_broYCostume2);
		(items[2] as IBronteSistersStoryLayout_broYCostume2).option = "astronaut";
		items[2].x = -284.5;
		items[2].y = -649;
		items[2].width = 569.00;
		items[2].height = 649.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"diver"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broYCostume3.call(items[3] as IBronteSistersStoryLayout_broYCostume3);
		(items[3] as IBronteSistersStoryLayout_broYCostume3).option = "diver";
		items[3].x = -284;
		items[3].y = -695;
		items[3].width = 568.00;
		items[3].height = 695.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broYCostume0(this: IBronteSistersStoryLayout_broYCostume0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-0.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broYCostume1(this: IBronteSistersStoryLayout_broYCostume1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broYCostume2(this: IBronteSistersStoryLayout_broYCostume2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-2.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broYCostume3(this: IBronteSistersStoryLayout_broYCostume3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-3.png", 0.000, 0.000);
	return this;
}
export function BronteSistersStoryLayout_scene2Xavier(this: IBronteSistersStoryLayout_scene2Xavier) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotYadina.call(items[0] as IBronteSistersStoryLayout_slotYadina);
		(items[0] as IBronteSistersStoryLayout_slotYadina).animation = "";
		(items[0] as IBronteSistersStoryLayout_slotYadina).isButton = true;
		(items[0] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[0].x = 699.3;
		items[0].y = 1219.05;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotXavier.call(items[1] as IBronteSistersStoryLayout_slotXavier);
		(items[1] as IBronteSistersStoryLayout_slotXavier).animation = "scaleUp ease=squishStretch";
		(items[1] as IBronteSistersStoryLayout_slotXavier).isButton = true;
		(items[1] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[1].x = 1285.95;
		items[1].y = 1221.7;
		if (items[1].scale) items[1].scale.x = -1.000;
		if (items[1].scale) items[1].scale.y = 1.000;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_slotXavier(this: IBronteSistersStoryLayout_slotXavier) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"clown"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broXCostume0.call(items[0] as IBronteSistersStoryLayout_broXCostume0);
		(items[0] as IBronteSistersStoryLayout_broXCostume0).option = "clown";
		items[0].x = -194;
		items[0].y = -750;
		items[0].width = 388.00;
		items[0].height = 750.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"caterpillar"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broXCostume1.call(items[1] as IBronteSistersStoryLayout_broXCostume1);
		(items[1] as IBronteSistersStoryLayout_broXCostume1).option = "caterpillar";
		items[1].x = -229.8;
		items[1].y = -767;
		items[1].width = 522.00;
		items[1].height = 767.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"baseball"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broXCostume2.call(items[2] as IBronteSistersStoryLayout_broXCostume2);
		(items[2] as IBronteSistersStoryLayout_broXCostume2).option = "baseball";
		items[2].x = -190.4;
		items[2].y = -693;
		items[2].width = 424.00;
		items[2].height = 693.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"pirate"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broXCostume3.call(items[3] as IBronteSistersStoryLayout_broXCostume3);
		(items[3] as IBronteSistersStoryLayout_broXCostume3).option = "pirate";
		items[3].x = -286.5;
		items[3].y = -752;
		items[3].width = 573.00;
		items[3].height = 752.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broXCostume0(this: IBronteSistersStoryLayout_broXCostume0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-0.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broXCostume1(this: IBronteSistersStoryLayout_broXCostume1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broXCostume2(this: IBronteSistersStoryLayout_broXCostume2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-2.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broXCostume3(this: IBronteSistersStoryLayout_broXCostume3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-3.png", 0.000, 0.000);
	return this;
}
export function BronteSistersStoryLayout_scene3Location(this: IBronteSistersStoryLayout_scene3Location) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_stotBackground.call(items[0] as IBronteSistersStoryLayout_stotBackground);
		(items[0] as IBronteSistersStoryLayout_stotBackground).animation = "scaleUp";
		(items[0] as IBronteSistersStoryLayout_stotBackground).isButton = true;
		(items[0] as IBronteSistersStoryLayout_stotBackground).option = "";
		items[0].x = 1020.8;
		items[0].y = 956.75;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		BronteSistersStoryLayout_paperLayer.call(items[1] as IBronteSistersStoryLayout_paperLayer);
		(items[1] as IBronteSistersStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		BronteSistersStoryLayout_slotYadina.call(items[2] as IBronteSistersStoryLayout_slotYadina);
		(items[2] as IBronteSistersStoryLayout_slotYadina).animation = "";
		(items[2] as IBronteSistersStoryLayout_slotYadina).isButton = true;
		(items[2] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[2].x = 699.3;
		items[2].y = 1219.05;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		BronteSistersStoryLayout_slotXavier.call(items[3] as IBronteSistersStoryLayout_slotXavier);
		(items[3] as IBronteSistersStoryLayout_slotXavier).animation = "";
		(items[3] as IBronteSistersStoryLayout_slotXavier).isButton = true;
		(items[3] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[3].x = 1285.95;
		items[3].y = 1221.7;
		if (items[3].scale) items[3].scale.x = -1.000;
		if (items[3].scale) items[3].scale.y = 1.000;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_stotBackground(this: IBronteSistersStoryLayout_stotBackground) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"library"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBgLibrary.call(items[0] as IBronteSistersStoryLayout_broBgLibrary);
		(items[0] as IBronteSistersStoryLayout_broBgLibrary).animation = "";
		(items[0] as IBronteSistersStoryLayout_broBgLibrary).isButton = false;
		(items[0] as IBronteSistersStoryLayout_broBgLibrary).option = "library";
		items[0].x = -995.45;
		items[0].y = -829.95;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"castle"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBgCastle.call(items[1] as IBronteSistersStoryLayout_broBgCastle);
		(items[1] as IBronteSistersStoryLayout_broBgCastle).animation = "";
		(items[1] as IBronteSistersStoryLayout_broBgCastle).isButton = false;
		(items[1] as IBronteSistersStoryLayout_broBgCastle).option = "castle";
		items[1].x = -577.85;
		items[1].y = -709.4;
		items[1].width = 1167.00;
		items[1].height = 717.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"garden"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broBgGarden.call(items[2] as IBronteSistersStoryLayout_broBgGarden);
		(items[2] as IBronteSistersStoryLayout_broBgGarden).animation = "";
		(items[2] as IBronteSistersStoryLayout_broBgGarden).isButton = false;
		(items[2] as IBronteSistersStoryLayout_broBgGarden).option = "garden";
		items[2].x = -1003.95;
		items[2].y = -637.2;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"pizza"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broBgPizza.call(items[3] as IBronteSistersStoryLayout_broBgPizza);
		(items[3] as IBronteSistersStoryLayout_broBgPizza).animation = "";
		(items[3] as IBronteSistersStoryLayout_broBgPizza).isButton = false;
		(items[3] as IBronteSistersStoryLayout_broBgPizza).option = "pizza";
		items[3].x = -924.8;
		items[3].y = -829.95;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBgLibrary(this: IBronteSistersStoryLayout_broBgLibrary) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBgLibrary3.call(items[0] as IBronteSistersStoryLayout_broBgLibrary3);
		items[0].x = 1048.7;
		items[0].y = 7.2;
		items[0].width = 569.00;
		items[0].height = 740.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBgLibrary2.call(items[1] as IBronteSistersStoryLayout_broBgLibrary2);
		items[1].x = 368.2;
		items[1].y = 0;
		items[1].width = 524.00;
		items[1].height = 747.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		BronteSistersStoryLayout_broBgLibrary4.call(items[2] as IBronteSistersStoryLayout_broBgLibrary4);
		items[2].x = 1425;
		items[2].y = 284;
		items[2].width = 580.00;
		items[2].height = 561.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		BronteSistersStoryLayout_broBgLibrary5.call(items[3] as IBronteSistersStoryLayout_broBgLibrary5);
		items[3].x = 280.4;
		items[3].y = 460.3;
		items[3].width = 284.00;
		items[3].height = 345.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		BronteSistersStoryLayout_broBgLibrary1.call(items[4] as IBronteSistersStoryLayout_broBgLibrary1);
		items[4].x = 0;
		items[4].y = 608;
		items[4].width = 719.00;
		items[4].height = 237.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		BronteSistersStoryLayout_broBgLibrary6.call(items[5] as IBronteSistersStoryLayout_broBgLibrary6);
		items[5].x = 1134.3;
		items[5].y = 555;
		items[5].width = 402.00;
		items[5].height = 290.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBgLibrary3(this: IBronteSistersStoryLayout_broBgLibrary3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library3.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgLibrary2(this: IBronteSistersStoryLayout_broBgLibrary2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library2.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgLibrary4(this: IBronteSistersStoryLayout_broBgLibrary4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library4.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgLibrary5(this: IBronteSistersStoryLayout_broBgLibrary5) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library5.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgLibrary1(this: IBronteSistersStoryLayout_broBgLibrary1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgLibrary6(this: IBronteSistersStoryLayout_broBgLibrary6) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library6.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgCastle(this: IBronteSistersStoryLayout_broBgCastle) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-castle.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgGarden(this: IBronteSistersStoryLayout_broBgGarden) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBgGarden3.call(items[0] as IBronteSistersStoryLayout_broBgGarden3);
		items[0].x = 1514.9;
		items[0].y = 80.5;
		items[0].width = 456.00;
		items[0].height = 594.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBgGarden1.call(items[1] as IBronteSistersStoryLayout_broBgGarden1);
		items[1].x = 0;
		items[1].y = 62.35;
		items[1].width = 454.00;
		items[1].height = 609.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		BronteSistersStoryLayout_broBgGarden2.call(items[2] as IBronteSistersStoryLayout_broBgGarden2);
		items[2].x = 1034.35;
		items[2].y = -60.45;
		items[2].width = 379.00;
		items[2].height = 536.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		BronteSistersStoryLayout_broBgGarden4.call(items[3] as IBronteSistersStoryLayout_broBgGarden4);
		items[3].x = 549;
		items[3].y = -42.75;
		items[3].width = 424.00;
		items[3].height = 445.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBgGarden3(this: IBronteSistersStoryLayout_broBgGarden3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden3.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgGarden1(this: IBronteSistersStoryLayout_broBgGarden1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgGarden2(this: IBronteSistersStoryLayout_broBgGarden2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden2.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgGarden4(this: IBronteSistersStoryLayout_broBgGarden4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden4.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgPizza(this: IBronteSistersStoryLayout_broBgPizza) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBgPizza4.call(items[0] as IBronteSistersStoryLayout_broBgPizza4);
		items[0].x = 548.1;
		items[0].y = -0.1;
		items[0].width = 399.00;
		items[0].height = 343.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBgPizza2.call(items[1] as IBronteSistersStoryLayout_broBgPizza2);
		items[1].x = 1306;
		items[1].y = 271;
		items[1].width = 433.00;
		items[1].height = 567.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		BronteSistersStoryLayout_broBgPizza1.call(items[2] as IBronteSistersStoryLayout_broBgPizza1);
		items[2].x = 0;
		items[2].y = 180.25;
		items[2].width = 561.00;
		items[2].height = 660.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		BronteSistersStoryLayout_broBgPizza3.call(items[3] as IBronteSistersStoryLayout_broBgPizza3);
		items[3].x = 359.8;
		items[3].y = 184;
		items[3].width = 359.00;
		items[3].height = 660.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		BronteSistersStoryLayout_broBgPizza4.call(items[4] as IBronteSistersStoryLayout_broBgPizza4);
		items[4].x = 1306.1;
		items[4].y = 0;
		items[4].width = -399.00;
		items[4].height = 343.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		BronteSistersStoryLayout_broBgPizza3.call(items[5] as IBronteSistersStoryLayout_broBgPizza3);
		items[5].x = 1494.4;
		items[5].y = 184.1;
		items[5].width = -359.00;
		items[5].height = 660.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBgPizza4(this: IBronteSistersStoryLayout_broBgPizza4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza4.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgPizza2(this: IBronteSistersStoryLayout_broBgPizza2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza2.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgPizza1(this: IBronteSistersStoryLayout_broBgPizza1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBgPizza3(this: IBronteSistersStoryLayout_broBgPizza3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza3.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_paperLayer(this: IBronteSistersStoryLayout_paperLayer) {
	return this;
}
export function BronteSistersStoryLayout_scene4Floor(this: IBronteSistersStoryLayout_scene4Floor) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_stotBackground.call(items[0] as IBronteSistersStoryLayout_stotBackground);
		(items[0] as IBronteSistersStoryLayout_stotBackground).animation = "";
		(items[0] as IBronteSistersStoryLayout_stotBackground).isButton = true;
		(items[0] as IBronteSistersStoryLayout_stotBackground).option = "";
		items[0].x = 1020.8;
		items[0].y = 956.75;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn up"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotFloor.call(items[1] as IBronteSistersStoryLayout_slotFloor);
		(items[1] as IBronteSistersStoryLayout_slotFloor).animation = "slideIn up";
		items[1].x = 0;
		items[1].y = 950.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		BronteSistersStoryLayout_broFloorRock1.call(items[2] as IBronteSistersStoryLayout_broFloorRock1);
		items[2].x = 1105.05;
		items[2].y = 1153.7;
		items[2].width = 446.00;
		items[2].height = 116.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		BronteSistersStoryLayout_broFloorRock0.call(items[3] as IBronteSistersStoryLayout_broFloorRock0);
		items[3].x = 500.3;
		items[3].y = 1153.7;
		items[3].width = 467.00;
		items[3].height = 116.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		BronteSistersStoryLayout_paperLayer.call(items[4] as IBronteSistersStoryLayout_paperLayer);
		(items[4] as IBronteSistersStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[5]) {
		BronteSistersStoryLayout_slotYadinaShocked.call(items[5] as IBronteSistersStoryLayout_slotYadinaShocked);
		(items[5] as IBronteSistersStoryLayout_slotYadinaShocked).animation = "scaleUp ease=squishStretch";
		(items[5] as IBronteSistersStoryLayout_slotYadinaShocked).isButton = true;
		(items[5] as IBronteSistersStoryLayout_slotYadinaShocked).option = "";
		items[5].x = 699.3;
		items[5].y = 1219.05;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[6]) {
		BronteSistersStoryLayout_slotXavierShocked.call(items[6] as IBronteSistersStoryLayout_slotXavierShocked);
		(items[6] as IBronteSistersStoryLayout_slotXavierShocked).animation = "scaleUp ease=squishStretch";
		(items[6] as IBronteSistersStoryLayout_slotXavierShocked).isButton = true;
		(items[6] as IBronteSistersStoryLayout_slotXavierShocked).option = "";
		items[6].x = 1357;
		items[6].y = 1221.7;
		if (items[6].scale) items[6].scale.x = -1.000;
		if (items[6].scale) items[6].scale.y = 1.000;
		if (items[6].onLayout) items[6].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_slotFloor(this: IBronteSistersStoryLayout_slotFloor) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"quicksand"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broFloorQuicksand.call(items[0] as IBronteSistersStoryLayout_broFloorQuicksand);
		(items[0] as IBronteSistersStoryLayout_broFloorQuicksand).option = "quicksand";
		items[0].x = -660.3;
		items[0].y = 0;
		items[0].width = 3404.00;
		items[0].height = 708.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"lava"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broFloorLava.call(items[1] as IBronteSistersStoryLayout_broFloorLava);
		(items[1] as IBronteSistersStoryLayout_broFloorLava).option = "lava";
		items[1].x = -622.8;
		items[1].y = 46.05;
		items[1].width = 3328.00;
		items[1].height = 540.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"pudding"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broFloorPudding.call(items[2] as IBronteSistersStoryLayout_broFloorPudding);
		(items[2] as IBronteSistersStoryLayout_broFloorPudding).option = "pudding";
		items[2].x = -622.8;
		items[2].y = 26.25;
		items[2].width = 3328.00;
		items[2].height = 626.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"ice"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broFloorIce.call(items[3] as IBronteSistersStoryLayout_broFloorIce);
		(items[3] as IBronteSistersStoryLayout_broFloorIce).option = "ice";
		items[3].x = -622.8;
		items[3].y = 41.1;
		items[3].width = 3328.00;
		items[3].height = 616.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broFloorQuicksand(this: IBronteSistersStoryLayout_broFloorQuicksand) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-quicksand.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broFloorLava(this: IBronteSistersStoryLayout_broFloorLava) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-lava.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broFloorPudding(this: IBronteSistersStoryLayout_broFloorPudding) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-pudding.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broFloorIce(this: IBronteSistersStoryLayout_broFloorIce) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-ice.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broFloorRock1(this: IBronteSistersStoryLayout_broFloorRock1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-rock-1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broFloorRock0(this: IBronteSistersStoryLayout_broFloorRock0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-rock-0.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_slotYadinaShocked(this: IBronteSistersStoryLayout_slotYadinaShocked) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"ringmaster"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broYCostume0.call(items[0] as IBronteSistersStoryLayout_broYCostume0);
		(items[0] as IBronteSistersStoryLayout_broYCostume0).option = "ringmaster";
		items[0].x = -291;
		items[0].y = -878;
		items[0].width = 582.00;
		items[0].height = 878.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"bug"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broYCostume1.call(items[1] as IBronteSistersStoryLayout_broYCostume1);
		(items[1] as IBronteSistersStoryLayout_broYCostume1).option = "bug";
		items[1].x = -286.5;
		items[1].y = -610;
		items[1].width = 573.00;
		items[1].height = 610.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"astronaut"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broYCostume2.call(items[2] as IBronteSistersStoryLayout_broYCostume2);
		(items[2] as IBronteSistersStoryLayout_broYCostume2).option = "astronaut";
		items[2].x = -284.5;
		items[2].y = -649;
		items[2].width = 569.00;
		items[2].height = 649.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"diver"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broYCostume3.call(items[3] as IBronteSistersStoryLayout_broYCostume3);
		(items[3] as IBronteSistersStoryLayout_broYCostume3).option = "diver";
		items[3].x = -284;
		items[3].y = -695;
		items[3].width = 568.00;
		items[3].height = 695.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"ringmaster"});
	}
	if (items[4]) {
		BronteSistersStoryLayout_broYCostume0Shocked.call(items[4] as IBronteSistersStoryLayout_broYCostume0Shocked);
		(items[4] as IBronteSistersStoryLayout_broYCostume0Shocked).option = "ringmaster";
		items[4].x = -95;
		items[4].y = -473.3;
		items[4].width = 273.00;
		items[4].height = 211.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"bug"});
	}
	if (items[5]) {
		BronteSistersStoryLayout_broYCostume1Shocked.call(items[5] as IBronteSistersStoryLayout_broYCostume1Shocked);
		(items[5] as IBronteSistersStoryLayout_broYCostume1Shocked).option = "bug";
		items[5].x = -76.85;
		items[5].y = -483.55;
		items[5].width = 241.00;
		items[5].height = 199.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"astronaut"});
	}
	if (items[6]) {
		BronteSistersStoryLayout_broYCostume2Shocked.call(items[6] as IBronteSistersStoryLayout_broYCostume2Shocked);
		(items[6] as IBronteSistersStoryLayout_broYCostume2Shocked).option = "astronaut";
		items[6].x = -95.7;
		items[6].y = -485.45;
		items[6].width = 274.00;
		items[6].height = 209.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"diver"});
	}
	if (items[7]) {
		BronteSistersStoryLayout_broYCostume3Shocked.call(items[7] as IBronteSistersStoryLayout_broYCostume3Shocked);
		(items[7] as IBronteSistersStoryLayout_broYCostume3Shocked).option = "diver";
		items[7].x = -88.15;
		items[7].y = -597.15;
		items[7].width = 271.00;
		items[7].height = 286.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broYCostume0Shocked(this: IBronteSistersStoryLayout_broYCostume0Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-0-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broYCostume1Shocked(this: IBronteSistersStoryLayout_broYCostume1Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-1-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broYCostume2Shocked(this: IBronteSistersStoryLayout_broYCostume2Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-2-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broYCostume3Shocked(this: IBronteSistersStoryLayout_broYCostume3Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-3-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_slotXavierShocked(this: IBronteSistersStoryLayout_slotXavierShocked) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"clown"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broXCostume0.call(items[0] as IBronteSistersStoryLayout_broXCostume0);
		(items[0] as IBronteSistersStoryLayout_broXCostume0).option = "clown";
		items[0].x = -194;
		items[0].y = -750;
		items[0].width = 388.00;
		items[0].height = 750.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"caterpillar"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broXCostume1.call(items[1] as IBronteSistersStoryLayout_broXCostume1);
		(items[1] as IBronteSistersStoryLayout_broXCostume1).option = "caterpillar";
		items[1].x = -229.8;
		items[1].y = -767;
		items[1].width = 522.00;
		items[1].height = 767.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"baseball"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broXCostume2.call(items[2] as IBronteSistersStoryLayout_broXCostume2);
		(items[2] as IBronteSistersStoryLayout_broXCostume2).option = "baseball";
		items[2].x = -190.4;
		items[2].y = -693;
		items[2].width = 424.00;
		items[2].height = 693.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"pirate"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broXCostume3.call(items[3] as IBronteSistersStoryLayout_broXCostume3);
		(items[3] as IBronteSistersStoryLayout_broXCostume3).option = "pirate";
		items[3].x = -286.5;
		items[3].y = -752;
		items[3].width = 573.00;
		items[3].height = 752.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"option":"clown"});
	}
	if (items[4]) {
		BronteSistersStoryLayout_broXCostume0Shocked.call(items[4] as IBronteSistersStoryLayout_broXCostume0Shocked);
		(items[4] as IBronteSistersStoryLayout_broXCostume0Shocked).option = "clown";
		items[4].x = -62.15;
		items[4].y = -530.8;
		items[4].width = 216.00;
		items[4].height = 207.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"option":"caterpillar"});
	}
	if (items[5]) {
		BronteSistersStoryLayout_broXCostume1Shocked.call(items[5] as IBronteSistersStoryLayout_broXCostume1Shocked);
		(items[5] as IBronteSistersStoryLayout_broXCostume1Shocked).option = "caterpillar";
		items[5].x = -30;
		items[5].y = -534.45;
		items[5].width = 194.00;
		items[5].height = 197.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"option":"baseball"});
	}
	if (items[6]) {
		BronteSistersStoryLayout_broXCostume2Shocked.call(items[6] as IBronteSistersStoryLayout_broXCostume2Shocked);
		(items[6] as IBronteSistersStoryLayout_broXCostume2Shocked).option = "baseball";
		items[6].x = -48.85;
		items[6].y = -529.75;
		items[6].width = 200.00;
		items[6].height = 208.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"pirate"});
	}
	if (items[7]) {
		BronteSistersStoryLayout_broXCostume3Shocked.call(items[7] as IBronteSistersStoryLayout_broXCostume3Shocked);
		(items[7] as IBronteSistersStoryLayout_broXCostume3Shocked).option = "pirate";
		items[7].x = -92.35;
		items[7].y = -554.3;
		items[7].width = 234.00;
		items[7].height = 245.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broXCostume0Shocked(this: IBronteSistersStoryLayout_broXCostume0Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-0-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broXCostume1Shocked(this: IBronteSistersStoryLayout_broXCostume1Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-1-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broXCostume2Shocked(this: IBronteSistersStoryLayout_broXCostume2Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-2-shocked.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broXCostume3Shocked(this: IBronteSistersStoryLayout_broXCostume3Shocked) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-3-shocked.png", 0.000, 0.000);
	return this;
}
export function BronteSistersStoryLayout_scene5Bard(this: IBronteSistersStoryLayout_scene5Bard) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_stotBackground.call(items[0] as IBronteSistersStoryLayout_stotBackground);
		(items[0] as IBronteSistersStoryLayout_stotBackground).animation = "";
		(items[0] as IBronteSistersStoryLayout_stotBackground).isButton = true;
		(items[0] as IBronteSistersStoryLayout_stotBackground).option = "";
		items[0].x = 1020.8;
		items[0].y = 956.75;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotFloor.call(items[1] as IBronteSistersStoryLayout_slotFloor);
		(items[1] as IBronteSistersStoryLayout_slotFloor).animation = "";
		items[1].x = 0;
		items[1].y = 950.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		BronteSistersStoryLayout_broFloorRock1.call(items[2] as IBronteSistersStoryLayout_broFloorRock1);
		items[2].x = 793.05;
		items[2].y = 1153.7;
		items[2].width = 446.00;
		items[2].height = 116.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		BronteSistersStoryLayout_broFloorRock0.call(items[3] as IBronteSistersStoryLayout_broFloorRock0);
		items[3].x = 188.3;
		items[3].y = 1153.7;
		items[3].width = 467.00;
		items[3].height = 116.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"follow brad"});
	}
	if (items[4]) {
		BronteSistersStoryLayout_broFloorRock2.call(items[4] as IBronteSistersStoryLayout_broFloorRock2);
		(items[4] as IBronteSistersStoryLayout_broFloorRock2).animation = "follow brad";
		items[4].x = 1560.85;
		items[4].y = 1271.6;
		items[4].width = 467.00;
		items[4].height = 116.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"isPaperLayer":true});
	}
	if (items[5]) {
		BronteSistersStoryLayout_paperLayer.call(items[5] as IBronteSistersStoryLayout_paperLayer);
		(items[5] as IBronteSistersStoryLayout_paperLayer).isPaperLayer = true;
		items[5].x = 0;
		items[5].y = 0;
		items[5].width = 2048.00;
		items[5].height = 1536.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"scaleUp ease=squishStretch","isButton":true,"option":""});
	}
	if (items[6]) {
		BronteSistersStoryLayout_slotBrad.call(items[6] as IBronteSistersStoryLayout_slotBrad);
		(items[6] as IBronteSistersStoryLayout_slotBrad).animation = "scaleUp ease=squishStretch";
		(items[6] as IBronteSistersStoryLayout_slotBrad).isButton = true;
		(items[6] as IBronteSistersStoryLayout_slotBrad).option = "";
		items[6].x = 1560.95;
		items[6].y = 1219.05;
		if (items[6].scale) items[6].scale.x = -1.000;
		if (items[6].scale) items[6].scale.y = 1.000;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":true,"option":""});
	}
	if (items[7]) {
		BronteSistersStoryLayout_slotXavier.call(items[7] as IBronteSistersStoryLayout_slotXavier);
		(items[7] as IBronteSistersStoryLayout_slotXavier).animation = "";
		(items[7] as IBronteSistersStoryLayout_slotXavier).isButton = true;
		(items[7] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[7].x = 973.95;
		items[7].y = 1221.7;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"","isButton":true,"option":""});
	}
	if (items[8]) {
		BronteSistersStoryLayout_slotYadina.call(items[8] as IBronteSistersStoryLayout_slotYadina);
		(items[8] as IBronteSistersStoryLayout_slotYadina).animation = "";
		(items[8] as IBronteSistersStoryLayout_slotYadina).isButton = true;
		(items[8] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[8].x = 387.3;
		items[8].y = 1219.05;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broFloorRock2(this: IBronteSistersStoryLayout_broFloorRock2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-rock-2.png", 0.501, 1.000);
	return this;
}
function BronteSistersStoryLayout_slotBrad(this: IBronteSistersStoryLayout_slotBrad) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"bikeman"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBCostume0.call(items[0] as IBronteSistersStoryLayout_broBCostume0);
		(items[0] as IBronteSistersStoryLayout_broBCostume0).option = "bikeman";
		items[0].x = -195.5;
		items[0].y = -697;
		items[0].width = 391.00;
		items[0].height = 697.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"option":"butterfly"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBCostume1.call(items[1] as IBronteSistersStoryLayout_broBCostume1);
		(items[1] as IBronteSistersStoryLayout_broBCostume1).option = "butterfly";
		items[1].x = -347.65;
		items[1].y = -853;
		items[1].width = 590.00;
		items[1].height = 853.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"bradman"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broBCostume2.call(items[2] as IBronteSistersStoryLayout_broBCostume2);
		(items[2] as IBronteSistersStoryLayout_broBCostume2).option = "bradman";
		items[2].x = -454;
		items[2].y = -625;
		items[2].width = 908.00;
		items[2].height = 625.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"option":"radbrad"});
	}
	if (items[3]) {
		BronteSistersStoryLayout_broBCostume3.call(items[3] as IBronteSistersStoryLayout_broBCostume3);
		(items[3] as IBronteSistersStoryLayout_broBCostume3).option = "radbrad";
		items[3].x = -191.5;
		items[3].y = -625;
		items[3].width = 383.00;
		items[3].height = 625.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBCostume0(this: IBronteSistersStoryLayout_broBCostume0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume0.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBCostume1(this: IBronteSistersStoryLayout_broBCostume1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume1.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBCostume2(this: IBronteSistersStoryLayout_broBCostume2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume2.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBCostume3(this: IBronteSistersStoryLayout_broBCostume3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume3.png", 0.000, 0.000);
	return this;
}
export function BronteSistersStoryLayout_scene6Rescue(this: IBronteSistersStoryLayout_scene6Rescue) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_stotBackground.call(items[0] as IBronteSistersStoryLayout_stotBackground);
		(items[0] as IBronteSistersStoryLayout_stotBackground).animation = "";
		(items[0] as IBronteSistersStoryLayout_stotBackground).isButton = true;
		(items[0] as IBronteSistersStoryLayout_stotBackground).option = "";
		items[0].x = 1020.8;
		items[0].y = 956.75;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotFloor.call(items[1] as IBronteSistersStoryLayout_slotFloor);
		(items[1] as IBronteSistersStoryLayout_slotFloor).animation = "";
		items[1].x = 0;
		items[1].y = 950.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"option":"bicycle"});
	}
	if (items[2]) {
		BronteSistersStoryLayout_rescueBicycleRocks.call(items[2] as IBronteSistersStoryLayout_rescueBicycleRocks);
		(items[2] as IBronteSistersStoryLayout_rescueBicycleRocks).option = "bicycle";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		BronteSistersStoryLayout_paperLayer.call(items[3] as IBronteSistersStoryLayout_paperLayer);
		(items[3] as IBronteSistersStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"bobIn right","isButton":true,"option":""});
	}
	if (items[4]) {
		BronteSistersStoryLayout_slotDinosaur.call(items[4] as IBronteSistersStoryLayout_slotDinosaur);
		(items[4] as IBronteSistersStoryLayout_slotDinosaur).animation = "bobIn right";
		(items[4] as IBronteSistersStoryLayout_slotDinosaur).isButton = true;
		(items[4] as IBronteSistersStoryLayout_slotDinosaur).option = "";
		items[4].x = 1442.5;
		items[4].y = 1115.6;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"slideIn right","isButton":true,"option":""});
	}
	if (items[5]) {
		BronteSistersStoryLayout_slotBoat.call(items[5] as IBronteSistersStoryLayout_slotBoat);
		(items[5] as IBronteSistersStoryLayout_slotBoat).animation = "slideIn right";
		(items[5] as IBronteSistersStoryLayout_slotBoat).isButton = true;
		(items[5] as IBronteSistersStoryLayout_slotBoat).option = "";
		items[5].x = 1100;
		items[5].y = 1092.95;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"slideIn right","isButton":true,"option":""});
	}
	if (items[6]) {
		BronteSistersStoryLayout_slotBalloon.call(items[6] as IBronteSistersStoryLayout_slotBalloon);
		(items[6] as IBronteSistersStoryLayout_slotBalloon).animation = "slideIn right";
		(items[6] as IBronteSistersStoryLayout_slotBalloon).isButton = true;
		(items[6] as IBronteSistersStoryLayout_slotBalloon).option = "";
		items[6].x = 1048.45;
		items[6].y = 909;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"option":"bicycle"});
	}
	if (items[7]) {
		BronteSistersStoryLayout_rescueBicycle.call(items[7] as IBronteSistersStoryLayout_rescueBicycle);
		(items[7] as IBronteSistersStoryLayout_rescueBicycle).option = "bicycle";
		items[7].x = 0;
		items[7].y = 0;
		if (items[7].onLayout) items[7].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_rescueBicycleRocks(this: IBronteSistersStoryLayout_rescueBicycleRocks) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broFloorRock1.call(items[0] as IBronteSistersStoryLayout_broFloorRock1);
		items[0].x = 793.05;
		items[0].y = 1153.7;
		items[0].width = 446.00;
		items[0].height = 116.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		BronteSistersStoryLayout_broFloorRock0.call(items[1] as IBronteSistersStoryLayout_broFloorRock0);
		items[1].x = 188.3;
		items[1].y = 1153.7;
		items[1].width = 467.00;
		items[1].height = 116.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":""});
	}
	if (items[2]) {
		BronteSistersStoryLayout_broFloorRock2.call(items[2] as IBronteSistersStoryLayout_broFloorRock2);
		(items[2] as IBronteSistersStoryLayout_broFloorRock2).animation = "";
		items[2].x = 1560.3;
		items[2].y = 1270.8;
		items[2].width = 467.00;
		items[2].height = 116.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_slotDinosaur(this: IBronteSistersStoryLayout_slotDinosaur) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"dinosaur"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_rescueDinosaur.call(items[0] as IBronteSistersStoryLayout_rescueDinosaur);
		(items[0] as IBronteSistersStoryLayout_rescueDinosaur).option = "dinosaur";
		items[0].x = -1442.5;
		items[0].y = -1115.6;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_rescueDinosaur(this: IBronteSistersStoryLayout_rescueDinosaur) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotYadina.call(items[0] as IBronteSistersStoryLayout_slotYadina);
		(items[0] as IBronteSistersStoryLayout_slotYadina).animation = "scaleUp delay=0.6 time=0.4";
		(items[0] as IBronteSistersStoryLayout_slotYadina).isButton = false;
		(items[0] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[0].x = 1400.15;
		items[0].y = 539.85;
		if (items[0].scale) items[0].scale.x = -0.560;
		if (items[0].scale) items[0].scale.y = 0.560;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotBrad.call(items[1] as IBronteSistersStoryLayout_slotBrad);
		(items[1] as IBronteSistersStoryLayout_slotBrad).animation = "scaleUp delay=0.6 time=0.4";
		(items[1] as IBronteSistersStoryLayout_slotBrad).isButton = false;
		(items[1] as IBronteSistersStoryLayout_slotBrad).option = "";
		items[1].x = 1011.5;
		items[1].y = 492.45;
		if (items[1].scale) items[1].scale.x = -0.560;
		if (items[1].scale) items[1].scale.y = 0.560;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[2]) {
		BronteSistersStoryLayout_slotXavier.call(items[2] as IBronteSistersStoryLayout_slotXavier);
		(items[2] as IBronteSistersStoryLayout_slotXavier).animation = "scaleUp delay=0.6 time=0.4";
		(items[2] as IBronteSistersStoryLayout_slotXavier).isButton = false;
		(items[2] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[2].x = 1212.75;
		items[2].y = 510.95;
		if (items[2].scale) items[2].scale.x = -0.560;
		if (items[2].scale) items[2].scale.y = 0.560;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		BronteSistersStoryLayout_broDino.call(items[3] as IBronteSistersStoryLayout_broDino);
		items[3].x = 494;
		items[3].y = 364.6;
		items[3].width = 1897.00;
		items[3].height = 751.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broDino(this: IBronteSistersStoryLayout_broDino) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-dino.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_slotBoat(this: IBronteSistersStoryLayout_slotBoat) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"boat"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_rescueBoat.call(items[0] as IBronteSistersStoryLayout_rescueBoat);
		(items[0] as IBronteSistersStoryLayout_rescueBoat).option = "boat";
		items[0].x = -1100;
		items[0].y = -1092.95;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_rescueBoat(this: IBronteSistersStoryLayout_rescueBoat) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBoatBack.call(items[0] as IBronteSistersStoryLayout_broBoatBack);
		items[0].x = 277;
		items[0].y = -85.05;
		items[0].width = 1646.00;
		items[0].height = 1178.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotYadina.call(items[1] as IBronteSistersStoryLayout_slotYadina);
		(items[1] as IBronteSistersStoryLayout_slotYadina).animation = "scaleUp delay=0.6 time=0.4";
		(items[1] as IBronteSistersStoryLayout_slotYadina).isButton = false;
		(items[1] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[1].x = 1283.4;
		items[1].y = 1002;
		if (items[1].scale) items[1].scale.x = -0.560;
		if (items[1].scale) items[1].scale.y = 0.560;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[2]) {
		BronteSistersStoryLayout_slotBrad.call(items[2] as IBronteSistersStoryLayout_slotBrad);
		(items[2] as IBronteSistersStoryLayout_slotBrad).animation = "scaleUp delay=0.6 time=0.4";
		(items[2] as IBronteSistersStoryLayout_slotBrad).isButton = false;
		(items[2] as IBronteSistersStoryLayout_slotBrad).option = "";
		items[2].x = 894.75;
		items[2].y = 954.6;
		if (items[2].scale) items[2].scale.x = -0.560;
		if (items[2].scale) items[2].scale.y = 0.560;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[3]) {
		BronteSistersStoryLayout_slotXavier.call(items[3] as IBronteSistersStoryLayout_slotXavier);
		(items[3] as IBronteSistersStoryLayout_slotXavier).animation = "scaleUp delay=0.6 time=0.4";
		(items[3] as IBronteSistersStoryLayout_slotXavier).isButton = false;
		(items[3] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[3].x = 1096;
		items[3].y = 973.1;
		if (items[3].scale) items[3].scale.x = -0.560;
		if (items[3].scale) items[3].scale.y = 0.560;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		BronteSistersStoryLayout_broBoatFront.call(items[4] as IBronteSistersStoryLayout_broBoatFront);
		items[4].x = 742;
		items[4].y = 842.85;
		items[4].width = 710.00;
		items[4].height = 234.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBoatBack(this: IBronteSistersStoryLayout_broBoatBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-boat-back.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBoatFront(this: IBronteSistersStoryLayout_broBoatFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-boat-front.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_slotBalloon(this: IBronteSistersStoryLayout_slotBalloon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"option":"balloon"});
	}
	if (items[0]) {
		BronteSistersStoryLayout_rescueBalloon.call(items[0] as IBronteSistersStoryLayout_rescueBalloon);
		(items[0] as IBronteSistersStoryLayout_rescueBalloon).option = "balloon";
		items[0].x = -1048.45;
		items[0].y = -909;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_rescueBalloon(this: IBronteSistersStoryLayout_rescueBalloon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBalloonBack.call(items[0] as IBronteSistersStoryLayout_broBalloonBack);
		items[0].x = 684.2;
		items[0].y = 0;
		items[0].width = 729.00;
		items[0].height = 909.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotYadina.call(items[1] as IBronteSistersStoryLayout_slotYadina);
		(items[1] as IBronteSistersStoryLayout_slotYadina).animation = "scaleUp delay=0.6 time=0.4";
		(items[1] as IBronteSistersStoryLayout_slotYadina).isButton = false;
		(items[1] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[1].x = 1241.45;
		items[1].y = 780.4;
		if (items[1].scale) items[1].scale.x = -0.560;
		if (items[1].scale) items[1].scale.y = 0.560;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[2]) {
		BronteSistersStoryLayout_slotBrad.call(items[2] as IBronteSistersStoryLayout_slotBrad);
		(items[2] as IBronteSistersStoryLayout_slotBrad).animation = "scaleUp delay=0.6 time=0.4";
		(items[2] as IBronteSistersStoryLayout_slotBrad).isButton = false;
		(items[2] as IBronteSistersStoryLayout_slotBrad).option = "";
		items[2].x = 852.8;
		items[2].y = 780.6;
		if (items[2].scale) items[2].scale.x = -0.560;
		if (items[2].scale) items[2].scale.y = 0.560;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"scaleUp delay=0.6 time=0.4","isButton":false,"option":""});
	}
	if (items[3]) {
		BronteSistersStoryLayout_slotXavier.call(items[3] as IBronteSistersStoryLayout_slotXavier);
		(items[3] as IBronteSistersStoryLayout_slotXavier).animation = "scaleUp delay=0.6 time=0.4";
		(items[3] as IBronteSistersStoryLayout_slotXavier).isButton = false;
		(items[3] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[3].x = 1054.05;
		items[3].y = 777;
		if (items[3].scale) items[3].scale.x = -0.560;
		if (items[3].scale) items[3].scale.y = 0.560;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		BronteSistersStoryLayout_broBalloonFront.call(items[4] as IBronteSistersStoryLayout_broBalloonFront);
		items[4].x = 683.75;
		items[4].y = 593;
		items[4].width = 729.00;
		items[4].height = 316.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBalloonBack(this: IBronteSistersStoryLayout_broBalloonBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-balloon-back.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_broBalloonFront(this: IBronteSistersStoryLayout_broBalloonFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-balloon-front.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_rescueBicycle(this: IBronteSistersStoryLayout_rescueBicycle) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotBicycleYadina.call(items[0] as IBronteSistersStoryLayout_slotBicycleYadina);
		(items[0] as IBronteSistersStoryLayout_slotBicycleYadina).animation = "";
		(items[0] as IBronteSistersStoryLayout_slotBicycleYadina).isButton = true;
		(items[0] as IBronteSistersStoryLayout_slotBicycleYadina).option = "";
		items[0].x = 387.3;
		items[0].y = 1256;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		BronteSistersStoryLayout_slotBicycleXavier.call(items[1] as IBronteSistersStoryLayout_slotBicycleXavier);
		(items[1] as IBronteSistersStoryLayout_slotBicycleXavier).animation = "";
		(items[1] as IBronteSistersStoryLayout_slotBicycleXavier).isButton = true;
		(items[1] as IBronteSistersStoryLayout_slotBicycleXavier).option = "";
		items[1].x = 991.55;
		items[1].y = 1255.8;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		BronteSistersStoryLayout_slotBicycleBrad.call(items[2] as IBronteSistersStoryLayout_slotBicycleBrad);
		(items[2] as IBronteSistersStoryLayout_slotBicycleBrad).animation = "";
		(items[2] as IBronteSistersStoryLayout_slotBicycleBrad).isButton = true;
		(items[2] as IBronteSistersStoryLayout_slotBicycleBrad).option = "";
		items[2].x = 1560.95;
		items[2].y = 1260;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_slotBicycleYadina(this: IBronteSistersStoryLayout_slotBicycleYadina) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotYadina.call(items[0] as IBronteSistersStoryLayout_slotYadina);
		(items[0] as IBronteSistersStoryLayout_slotYadina).animation = "";
		(items[0] as IBronteSistersStoryLayout_slotYadina).isButton = false;
		(items[0] as IBronteSistersStoryLayout_slotYadina).option = "";
		items[0].x = 0;
		items[0].y = -36.95;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn left delay=0.4"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBicycle1.call(items[1] as IBronteSistersStoryLayout_broBicycle1);
		(items[1] as IBronteSistersStoryLayout_broBicycle1).animation = "slideIn left delay=0.4";
		items[1].x = 232.4;
		items[1].y = -227;
		if (items[1].scale) items[1].scale.x = -1.000;
		if (items[1].scale) items[1].scale.y = 1.000;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBicycle1(this: IBronteSistersStoryLayout_broBicycle1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		BronteSistersStoryLayout_broBicycle.call(items[0] as IBronteSistersStoryLayout_broBicycle);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 382.00;
		items[0].height = 227.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_broBicycle(this: IBronteSistersStoryLayout_broBicycle) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bicycle.png", 0.000, 0.000);
	return this;
}
function BronteSistersStoryLayout_slotBicycleXavier(this: IBronteSistersStoryLayout_slotBicycleXavier) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotXavier.call(items[0] as IBronteSistersStoryLayout_slotXavier);
		(items[0] as IBronteSistersStoryLayout_slotXavier).animation = "";
		(items[0] as IBronteSistersStoryLayout_slotXavier).isButton = false;
		(items[0] as IBronteSistersStoryLayout_slotXavier).option = "";
		items[0].x = -17.6;
		items[0].y = -34.1;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn left"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBicycle1.call(items[1] as IBronteSistersStoryLayout_broBicycle1);
		(items[1] as IBronteSistersStoryLayout_broBicycle1).animation = "slideIn left";
		items[1].x = 211.65;
		items[1].y = -227;
		if (items[1].scale) items[1].scale.x = -1.000;
		if (items[1].scale) items[1].scale.y = 1.000;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function BronteSistersStoryLayout_slotBicycleBrad(this: IBronteSistersStoryLayout_slotBicycleBrad) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		BronteSistersStoryLayout_slotBrad.call(items[0] as IBronteSistersStoryLayout_slotBrad);
		(items[0] as IBronteSistersStoryLayout_slotBrad).animation = "";
		(items[0] as IBronteSistersStoryLayout_slotBrad).isButton = false;
		(items[0] as IBronteSistersStoryLayout_slotBrad).option = "";
		items[0].x = 0;
		items[0].y = -40.95;
		if (items[0].scale) items[0].scale.x = -1.000;
		if (items[0].scale) items[0].scale.y = 1.000;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn right"});
	}
	if (items[1]) {
		BronteSistersStoryLayout_broBicycle1.call(items[1] as IBronteSistersStoryLayout_broBicycle1);
		(items[1] as IBronteSistersStoryLayout_broBicycle1).animation = "slideIn right";
		items[1].x = -186.95;
		items[1].y = -227;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
interface IBronteSistersStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IBronteSistersStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IBronteSistersStoryLayoutSprite extends IBronteSistersStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IBronteSistersStoryLayoutText extends IBronteSistersStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IBronteSistersStoryLayoutPolygon extends Array<number> {
}
interface IBronteSistersStoryLayout {
	readonly scene1Yadina: IBronteSistersStoryLayout_scene1Yadina;
	readonly scene2Xavier: IBronteSistersStoryLayout_scene2Xavier;
	readonly scene3Location: IBronteSistersStoryLayout_scene3Location;
	readonly scene4Floor: IBronteSistersStoryLayout_scene4Floor;
	readonly scene5Bard: IBronteSistersStoryLayout_scene5Bard;
	readonly scene6Rescue: IBronteSistersStoryLayout_scene6Rescue;
}
interface IBronteSistersStoryLayout_scene1Yadina extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotYadina>;
}
interface IBronteSistersStoryLayout_slotYadina extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broYCostume0|IBronteSistersStoryLayout_broYCostume1|IBronteSistersStoryLayout_broYCostume2|IBronteSistersStoryLayout_broYCostume3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume0 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume1 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume2 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume3 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_scene2Xavier extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotYadina|IBronteSistersStoryLayout_slotXavier>;
}
interface IBronteSistersStoryLayout_slotXavier extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broXCostume0|IBronteSistersStoryLayout_broXCostume1|IBronteSistersStoryLayout_broXCostume2|IBronteSistersStoryLayout_broXCostume3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume0 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume1 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume2 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume3 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_scene3Location extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_stotBackground|IBronteSistersStoryLayout_paperLayer|IBronteSistersStoryLayout_slotYadina|IBronteSistersStoryLayout_slotXavier>;
}
interface IBronteSistersStoryLayout_stotBackground extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBgLibrary|IBronteSistersStoryLayout_broBgCastle|IBronteSistersStoryLayout_broBgGarden|IBronteSistersStoryLayout_broBgPizza>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBgLibrary extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBgLibrary3|IBronteSistersStoryLayout_broBgLibrary2|IBronteSistersStoryLayout_broBgLibrary4|IBronteSistersStoryLayout_broBgLibrary5|IBronteSistersStoryLayout_broBgLibrary1|IBronteSistersStoryLayout_broBgLibrary6>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBgLibrary3 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgLibrary2 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgLibrary4 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgLibrary5 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgLibrary1 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgLibrary6 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgCastle extends IBronteSistersStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBgGarden extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBgGarden3|IBronteSistersStoryLayout_broBgGarden1|IBronteSistersStoryLayout_broBgGarden2|IBronteSistersStoryLayout_broBgGarden4>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBgGarden3 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgGarden1 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgGarden2 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgGarden4 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgPizza extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBgPizza4|IBronteSistersStoryLayout_broBgPizza2|IBronteSistersStoryLayout_broBgPizza1|IBronteSistersStoryLayout_broBgPizza3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBgPizza4 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgPizza2 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgPizza1 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBgPizza3 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_paperLayer extends IBronteSistersStoryLayoutContainer {
	isPaperLayer: boolean;
}
interface IBronteSistersStoryLayout_scene4Floor extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_stotBackground|IBronteSistersStoryLayout_slotFloor|IBronteSistersStoryLayout_broFloorRock1|IBronteSistersStoryLayout_broFloorRock0|IBronteSistersStoryLayout_paperLayer|IBronteSistersStoryLayout_slotYadinaShocked|IBronteSistersStoryLayout_slotXavierShocked>;
}
interface IBronteSistersStoryLayout_slotFloor extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broFloorQuicksand|IBronteSistersStoryLayout_broFloorLava|IBronteSistersStoryLayout_broFloorPudding|IBronteSistersStoryLayout_broFloorIce>;
	animation: string;
}
interface IBronteSistersStoryLayout_broFloorQuicksand extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broFloorLava extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broFloorPudding extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broFloorIce extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broFloorRock1 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broFloorRock0 extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_slotYadinaShocked extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broYCostume0|IBronteSistersStoryLayout_broYCostume1|IBronteSistersStoryLayout_broYCostume2|IBronteSistersStoryLayout_broYCostume3|IBronteSistersStoryLayout_broYCostume0Shocked|IBronteSistersStoryLayout_broYCostume1Shocked|IBronteSistersStoryLayout_broYCostume2Shocked|IBronteSistersStoryLayout_broYCostume3Shocked>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume0Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume1Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume2Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broYCostume3Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_slotXavierShocked extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broXCostume0|IBronteSistersStoryLayout_broXCostume1|IBronteSistersStoryLayout_broXCostume2|IBronteSistersStoryLayout_broXCostume3|IBronteSistersStoryLayout_broXCostume0Shocked|IBronteSistersStoryLayout_broXCostume1Shocked|IBronteSistersStoryLayout_broXCostume2Shocked|IBronteSistersStoryLayout_broXCostume3Shocked>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume0Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume1Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume2Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broXCostume3Shocked extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_scene5Bard extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_stotBackground|IBronteSistersStoryLayout_slotFloor|IBronteSistersStoryLayout_broFloorRock1|IBronteSistersStoryLayout_broFloorRock0|IBronteSistersStoryLayout_broFloorRock2|IBronteSistersStoryLayout_paperLayer|IBronteSistersStoryLayout_slotBrad|IBronteSistersStoryLayout_slotXavier|IBronteSistersStoryLayout_slotYadina>;
}
interface IBronteSistersStoryLayout_broFloorRock2 extends IBronteSistersStoryLayoutSprite {
	animation: string;
}
interface IBronteSistersStoryLayout_slotBrad extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBCostume0|IBronteSistersStoryLayout_broBCostume1|IBronteSistersStoryLayout_broBCostume2|IBronteSistersStoryLayout_broBCostume3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBCostume0 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broBCostume1 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broBCostume2 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_broBCostume3 extends IBronteSistersStoryLayoutSprite {
	option: string;
}
interface IBronteSistersStoryLayout_scene6Rescue extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_stotBackground|IBronteSistersStoryLayout_slotFloor|IBronteSistersStoryLayout_rescueBicycleRocks|IBronteSistersStoryLayout_paperLayer|IBronteSistersStoryLayout_slotDinosaur|IBronteSistersStoryLayout_slotBoat|IBronteSistersStoryLayout_slotBalloon|IBronteSistersStoryLayout_rescueBicycle>;
}
interface IBronteSistersStoryLayout_rescueBicycleRocks extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broFloorRock1|IBronteSistersStoryLayout_broFloorRock0|IBronteSistersStoryLayout_broFloorRock2>;
	option: string;
}
interface IBronteSistersStoryLayout_slotDinosaur extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_rescueDinosaur>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_rescueDinosaur extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotYadina|IBronteSistersStoryLayout_slotBrad|IBronteSistersStoryLayout_slotXavier|IBronteSistersStoryLayout_broDino>;
	option: string;
}
interface IBronteSistersStoryLayout_broDino extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_slotBoat extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_rescueBoat>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_rescueBoat extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBoatBack|IBronteSistersStoryLayout_slotYadina|IBronteSistersStoryLayout_slotBrad|IBronteSistersStoryLayout_slotXavier|IBronteSistersStoryLayout_broBoatFront>;
	option: string;
}
interface IBronteSistersStoryLayout_broBoatBack extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBoatFront extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_slotBalloon extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_rescueBalloon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_rescueBalloon extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBalloonBack|IBronteSistersStoryLayout_slotYadina|IBronteSistersStoryLayout_slotBrad|IBronteSistersStoryLayout_slotXavier|IBronteSistersStoryLayout_broBalloonFront>;
	option: string;
}
interface IBronteSistersStoryLayout_broBalloonBack extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_broBalloonFront extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_rescueBicycle extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotBicycleYadina|IBronteSistersStoryLayout_slotBicycleXavier|IBronteSistersStoryLayout_slotBicycleBrad>;
	option: string;
}
interface IBronteSistersStoryLayout_slotBicycleYadina extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotYadina|IBronteSistersStoryLayout_broBicycle1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_broBicycle1 extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_broBicycle>;
	animation: string;
}
interface IBronteSistersStoryLayout_broBicycle extends IBronteSistersStoryLayoutSprite {
}
interface IBronteSistersStoryLayout_slotBicycleXavier extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotXavier|IBronteSistersStoryLayout_broBicycle1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IBronteSistersStoryLayout_slotBicycleBrad extends IBronteSistersStoryLayoutContainer {
	readonly items: IBronteSistersStoryLayoutArray<IBronteSistersStoryLayout_slotBrad|IBronteSistersStoryLayout_broBicycle1>;
	animation: string;
	isButton: boolean;
	option: string;
}
